import React, { useEffect, useState } from 'react';
import { makeStyles } from '@material-ui/styles';
import { Grid } from '@material-ui/core';
import { isAuthenticated } from '../../helpers/authenticate';
import {
  FiliadosGeral,
  GraficoCalibresMaisProcurados,
  GraficoCalibresMaisUsados,
  GraficoDiasSemanaMaisFiliadosAtivos,
  GraficoDiasSemanaMaisVisitantes,
  GraficoModalidadesMaisUsadas,
  GraficoPerdasInsumos,
  GraficoVisitasPorMes,
  ListagemFiliadosMaisLucrativos,
  ValorVisitasMes,
  VisitasGeral,
  VisitasPorMes
} from './components';
import SnackbarCustom from '../../components/Compartilhados/Snackbar';
import ProgressFullScreen from '../../components/Compartilhados/ProgressFullScreen';

const useStyles = makeStyles(theme => ({
  root: {
    padding: theme.spacing(4)
  }
}));

const Dashboard = ({ history }) => {
  const classes = useStyles();
  const [showMessageSnack, setShowMessageSnack] = useState(false);
  const [messageSnack, setMessageSnack] = useState('');
  const [typeSnack, setTypeSnack] = useState('success');
  const [loading, setLoading] = React.useState(false);
  const [modoAnonimo, setModoAnonimo] = useState(false);

  useEffect(() => {
    const anonimo = JSON.parse(localStorage.getItem('modoAnonimo'));
    setModoAnonimo(anonimo);
  }, []);

  useEffect(() => {
    function checkAuth() {
      isAuthenticated(history);
    }
    checkAuth();
  }, []);

  return (
    <div className={classes.root}>
      <SnackbarCustom
        verticalOrientation="bottom"
        horizontalOrientation="center"
        open={showMessageSnack}
        setOpen={setShowMessageSnack}
        message={messageSnack}
        duration={2000}
        type={typeSnack}
      />
      <ProgressFullScreen open={loading} setOpen={setLoading} />
      <Grid container spacing={4}>
        <Grid item lg={3} sm={6} xl={3} xs={12}>
          <VisitasPorMes />
        </Grid>
        <Grid item lg={3} sm={6} xl={3} xs={12}>
          <VisitasGeral />
        </Grid>
        <Grid item lg={3} sm={6} xl={3} xs={12}>
          <FiliadosGeral />
        </Grid>
        <Grid item lg={3} sm={6} xl={3} xs={12}>
          <ValorVisitasMes />
        </Grid>
        <Grid item md={12} sm={12} xs={12}>
          <GraficoVisitasPorMes />
        </Grid>
        <Grid item md={6} sm={12} xs={12}>
          <GraficoModalidadesMaisUsadas />
        </Grid>
        <Grid item md={6} sm={12} xs={12}>
          <ListagemFiliadosMaisLucrativos
            history={history}
            setShowMessageSnack={setShowMessageSnack}
            setMessageSnack={setMessageSnack}
            setTypeSnack={setTypeSnack}
            setLoading={setLoading}
          />
        </Grid>
        <Grid item md={6} sm={6} xs={12}>
          <GraficoCalibresMaisProcurados />
        </Grid>
        <Grid item md={6} sm={6} xs={12}>
          <GraficoCalibresMaisUsados />
        </Grid>
        <Grid item md={12} sm={12} xs={12}>
          <GraficoPerdasInsumos />
        </Grid>
        {!modoAnonimo && (
          <Grid item md={6} sm={12} xs={12}>
            <GraficoDiasSemanaMaisVisitantes />
          </Grid>
        )}
        <Grid item md={modoAnonimo ? 12 : 6} sm={12} xs={12}>
          <GraficoDiasSemanaMaisFiliadosAtivos />
        </Grid>
      </Grid>
    </div>
  );
};

export default Dashboard;
